// src/config/seo.js
import { CONTACTS } from './contacts.js';

export const SITE_URL = 'https://www.momv.com.ua';
export const SITE_NAME = 'MOMV';
export const DEFAULT_META_IMAGE = '/images/placeholder3.jpg';

export const SUPPORTED_LOCALES = [
  { code: 'ua', hrefLang: 'uk-UA', twitter: 'uk', default: true },
  { code: 'en', hrefLang: 'en-US', twitter: 'en' }
];

export const toAbsoluteUrl = (value) => {
  if (!value) return undefined;
  if (value.startsWith('http://') || value.startsWith('https://')) {
    return value;
  }
  const normalized = value.startsWith('/') ? value : `/${value}`;
  return `${SITE_URL}${normalized}`;
};

export const buildPageUrl = (path = '/', locale = 'ua') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const localeInfo = SUPPORTED_LOCALES.find((item) => item.code === locale);
  const search = localeInfo && !localeInfo.default ? `?lang=${locale}` : '';
  return `${SITE_URL}${normalizedPath}${search}`;
};

export const buildAlternateLinks = (path = '/') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const links = SUPPORTED_LOCALES.map((locale) => ({
    hrefLang: locale.hrefLang,
    href: buildPageUrl(normalizedPath, locale.code),
  }));

  const defaultLocale = SUPPORTED_LOCALES.find((locale) => locale.default) || SUPPORTED_LOCALES[0];
  if (defaultLocale) {
    links.push({ hrefLang: 'x-default', href: buildPageUrl(normalizedPath, defaultLocale.code) });
  }

  return links;
};

export const ORGANIZATION_LD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_URL,
  logo: toAbsoluteUrl('/logo.png'),
  contactPoint: CONTACTS.phones.map((phone) => ({
    '@type': 'ContactPoint',
    telephone: phone.tel,
    contactType: 'customer service',
    availableLanguage: ['uk', 'en'],
  })),
  sameAs: CONTACTS.telegram ? [CONTACTS.telegram] : [],
};
